import { FormConfiguration } from "../../shared/crud/form";
import { PropertyTickersListSelector } from "../../shared/widgets/propertyTickersListSelector";
import { CreatePropertyOptionsWidget } from "../CreatePropertyOptionsWidget";
import { messages } from "../messages";
import { CreatePropertyEntity } from "./createProperty.entity";

export function buildFormConfiguration(): FormConfiguration<CreatePropertyEntity> {
  return {
    __fieldOrder: ["originPropertyTicker", "targetPropertyTicker", "options"],
    originPropertyTicker: {
      messages: {
        label: messages.originPropertyTicker,
      },
      widget: PropertyTickersListSelector,
    },
    targetPropertyTicker: {
      messages: {
        label: messages.targetPropertyTicker,
      },
    },
    options: {
      messages: {
        label: messages.options,
      },
      fieldWidget: CreatePropertyOptionsWidget,
    },
  };
}
